import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";

const styles = {
  paper: {
    borderRadius: 2,
    minHeight: 250,
  },
  dialogTitle: {
    textAlign: "center",
    pt: 4,
    pb: 2,
  },
  title: {
    fontWeight: "500",
  },
  linearProgress: {
    height: 8,
    borderRadius: 4,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    "& .MuiLinearProgress-bar": {
      borderRadius: 4,
    },
  },
};

export default function ActionProgressModal({
  open,
  progress,
  total,
  title = "Processing",
  actionLabel = "processed",
}) {
  const percentage = total > 0 ? Math.round((progress / total) * 100) : 0;

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: styles.paper,
      }}
    >
      <DialogTitle sx={styles.dialogTitle}>
        <Typography variant="h5" sx={styles.title} color="textPrimary">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={3}
          py={2}
        >
          <Box position="relative" display="inline-flex">
            <CircularProgress size={80} thickness={4} />
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Typography variant="h5" component="div" fontWeight="600" color="textPrimary">
                {percentage}%
              </Typography>
            </Box>
          </Box>
          <Box width="100%" px={2}>
            <LinearProgress variant="determinate" value={percentage} sx={styles.linearProgress} />
          </Box>
          <Typography variant="body1" color="text.secondary" fontWeight="500">
            {progress} of {total} items {actionLabel}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait while items are being {actionLabel} by the system...
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
